import { Badge, Box, Flex, Title } from "@mantine/core";
import { PropsWithChildren, ReactElement } from "react";
import { ITitleWithIconProps } from "./types";
import { WhiteSpaceMixin } from "@common/constants/theme-mantine/utils";

export default function TitleWithIcon({
  children,
  icon,
  title,
  order = 1,
  size = "h4",
  gap,
  isNew,
  extraContent,
  ...titleProps
}: PropsWithChildren<ITitleWithIconProps>): ReactElement {
  return (
    <Flex
      align="center"
      direction="row"
      justify="space-between"
      wrap="nowrap"
      w="100%"
    >
      <Flex
        align="flex-start"
        direction="row"
        gap="sm"
        justify="flex-start"
        wrap="nowrap"
        w="100%"
      >
        <Flex
          align={{ base: "flex-start", sm: "center" }}
          direction={{ base: "column", sm: "row" }}
          gap={{ base: 0, sm: "sm" }}
          justify="flex-start"
          wrap="nowrap"
          w="100%"
        >
          <Flex
            align="center"
            direction="row"
            justify="flex-start"
            wrap="nowrap"
            miw={140}
          >
            <Flex align="center" mr={gap || "sm"} miw={16} mt={1}>
              {icon}
            </Flex>
            {typeof title === "string" ? (
              <Title
                order={order}
                size={size}
                m={0}
                style={WhiteSpaceMixin()}
                {...titleProps}
              >
                {title}
              </Title>
            ) : (
              title
            )}
          </Flex>

          <Flex align="baseline" ml={28} w="100%">
            {children}
          </Flex>
        </Flex>

        {isNew && (
          <Box>
            <Badge size="sm" radius="sm" variant="filled" bg="brand.4">
              New
            </Badge>
          </Box>
        )}
      </Flex>

      {extraContent && <Box>{extraContent}</Box>}
    </Flex>
  );
}
